import HomeProjects from "../components/HomeProjects/HomeProjects";

function Projects() {
  return (
    <div>
      <HomeProjects />
    </div>
  );
}
export default Projects;
